import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { MAP_LAYERS } from '../../constants/mapLayers';

function SetupPopup({ isOpen, onClose, currentMapId, onMapSelect }) {
    const [selectedId, setSelectedId] = useState(currentMapId);

    useEffect(() => {
        setSelectedId(currentMapId);
    }, [currentMapId, isOpen]);

    if (!isOpen) return null;

    const handleSelect = (id) => {
        setSelectedId(id);
        onMapSelect(id);
        // Optional: close on select? User might want to see it change. 
        // Let's keep it open until they close it.
    };

    return ReactDOM.createPortal(
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
            <div className="bg-white/90 backdrop-blur rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in duration-200">
                {/* Header */}
                <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
                    <div className="flex items-center gap-2 text-slate-800">
                        <span className="material-symbols-outlined text-primary text-xl">settings</span>
                        <h2 className="text-lg font-bold uppercase tracking-tight">Setup</h2>
                    </div>
                    <button
                        onClick={onClose}
                        className="p-1 rounded-full hover:bg-slate-100 transition-colors text-slate-500"
                    >
                        <span className="material-symbols-outlined">close</span>
                    </button>
                </div>

                {/* Body */}
                <div className="p-6">
                    <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-3">
                        Map Layer
                    </h3>
                    <div className="space-y-2">
                        {MAP_LAYERS.map((layer) => (
                            <div
                                key={layer.id}
                                onClick={() => handleSelect(layer.id)}
                                className={`
                                    flex items-center gap-3 p-3 rounded-xl border-2 cursor-pointer transition-all
                                    ${selectedId === layer.id
                                        ? 'border-blue-500 bg-blue-50/50'
                                        : 'border-transparent bg-white hover:bg-slate-50 hover:border-slate-200 shadow-sm'
                                    }
                                `}
                            >
                                <div className={`
                                    w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0
                                    ${selectedId === layer.id ? 'border-blue-500' : 'border-slate-300'}
                                `}>
                                    {selectedId === layer.id && (
                                        <div className="w-2.5 h-2.5 rounded-full bg-blue-500" />
                                    )}
                                </div>
                                <div>
                                    <div className={`font-bold text-sm ${selectedId === layer.id ? 'text-blue-700' : 'text-slate-700'}`}>
                                        {layer.name}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Footer */}
                <div className="px-6 py-4 bg-slate-50/50 border-t border-gray-100 flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-slate-200 hover:bg-slate-300 text-slate-700 font-bold text-xs uppercase tracking-wider rounded-lg transition-colors"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}

export default SetupPopup;
